<template>
  <thead>
    <!-- 1行目 -->
    <tr>
      <th rowspan="3" :style="{ width: `${tableColWidth.col1}px` }">
        <ListTableHeaderItem name="★" sort-name="list_star" @search="search" />
      </th>
      <template v-for="columnItem in column">
        <th
          v-if="columnItem.column_id === 1 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          rowspan="3"
          :style="{ width: `${tableColWidth.col2}px` }"
        >
          <ListTableHeaderItem name="物件ID" sort-name="id" @search="search" />
          <ListTableHeaderItem name="物件管理番号" sort-name="control_no" @search="search" />
          <ListTableHeaderItem name="登録店舗" sort-name="created_shop" @search="search" />
          <ListTableHeaderItem name="自社担当者" sort-name="charge_person" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 2 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          rowspan="3"
          :style="{ width: `${tableColWidth.col3}px` }"
        >
          <ListTableHeaderItem name="外観・間取り" :sort="false" />
        </th>
        <th
          v-if="columnItem.column_id === 3 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          :style="{ width: `${tableColWidth.col4}px` }"
        >
          <ListTableHeaderItem name="種別" sort-name="m_b_type" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 4 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          rowspan="3"
          :style="{ width: `${tableColWidth.col5}px` }"
        >
          <ListTableHeaderItem name="住所" sort-name="address" @search="search" />
          <ListTableHeaderItem name="駅" sort-name="station" @search="search" inline style="margin-right: 4px;" />
          ・
          <ListTableHeaderItem name="徒歩" sort-name="station_walking_minutes" inline @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 5 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          :style="{ width: `${tableColWidth.col6}px` }"
        >
          <ListTableHeaderItem name="間取り" sort-name="house_plan" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 6 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          :style="{ width: `${tableColWidth.col7}px` }"
          class="editable"
        >
          <ListTableHeaderItem name="価格" sort-name="price" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 7 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          :style="{ width: `${tableColWidth.col8}px` }"
        >
          <ListTableHeaderItem name="土地面積" sort-name="land_area" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 8 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          rowspan="3"
          :style="{ width: `${tableColWidth.col9}px` }"
          class="editable"
        >
          <ListTableHeaderItem name="取引態様" sort-name="transaction_form" @search="search" />
          <ListTableHeaderItem name="確認日" sort-name="confirm_date" @search="search" />
          <ListTableHeaderItem name="販売状態" sort-name="sale_state" @search="search" />
          <ListTableHeaderItem name="現況" sort-name="vacant_type" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 9 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          :style="{ width: `${tableColWidth.col10}px` }"
        >
          <ListTableHeaderItem name="権利" sort-name="right_of_site" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 10 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          :style="{ width: `${tableColWidth.col11}px` }"
        >
          <ListTableHeaderItem name="坪単価" :sort="false" />
        </th>
        <th
          v-if="columnItem.column_id === 11 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          :style="{ width: `${tableColWidth.col12}px` }"
          class="editable"
        >
          <ListTableHeaderItem name="利回り" sort-name="yield" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 12 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          rowspan="3"
          :style="{ width: `${tableColWidth.col13}px` }"
          class="editable"
        >
          <ListTableHeaderItem name="クローズ情報" sort-name="close_info" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 13 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          rowspan="3"
          :style="{ width: `${tableColWidth.col14}px` }"
          class="editable"
        >
          <ListTableHeaderItem name="フリータグ" :sort="false" />
        </th>
        <th
          v-if="columnItem.column_id === 14 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          rowspan="3"
          :style="{ width: `${tableColWidth.col15}px` }"
        >
          <ListTableHeaderItem name="備考" :sort="false" />
        </th>
        <th
          v-if="columnItem.column_id === 15 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          rowspan="3"
          :style="{ width: `${tableColWidth.col16}px` }"
        >
          <ListTableHeaderItem name="作成日" sort-name="created_at" @search="search" />
          <ListTableHeaderItem name="更新日" sort-name="updated_at" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 16 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          rowspan="3"
          :style="{ width: `${tableColWidth.col17}px` }"
        >
          <ListTableHeaderItem name="業者名" sort-name="ea_name" @search="search" />
          <ListTableHeaderItem name="担当者・連絡先" sort-name="ea_charge_parson" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 17 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          rowspan="3"
          :style="{ width: `${tableColWidth.col18}px` }"
        >
          <ListTableHeaderItem name="画像数" sort-name="image_num" @search="search" />
          <ListTableHeaderItem name="パノラマ画像数" sort-name="panorama_num" @search="search" />
        </th>
      </template>
    </tr>

    <!-- 2行目 -->
    <tr>
      <template v-for="columnItem in column">
        <th v-if="columnItem.column_id === 3 && columnItem.f_display === 1" :key="columnItem.column_id">
          <ListTableHeaderItem name="物件名" sort-name="property_name" @search="search" />
        </th>
        <th v-if="columnItem.column_id === 5 && columnItem.f_display === 1" :key="columnItem.column_id">
          <ListTableHeaderItem name="築年数" sort-name="build_year" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 6 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          class="editable"
        >
          <ListTableHeaderItem name="管理費" sort-name="management_fee" @search="search" />
        </th>
        <th v-if="columnItem.column_id === 7 && columnItem.f_display === 1" :key="columnItem.column_id">
          <ListTableHeaderItem name="建物面積" sort-name="building_area" @search="search" />
        </th>
        <th v-if="columnItem.column_id === 9 && columnItem.f_display === 1" :key="columnItem.column_id">
          <ListTableHeaderItem name="建ぺい率" sort-name="land_coverage_ratio" @search="search" />
        </th>
        <th v-if="columnItem.column_id === 10 && columnItem.f_display === 1" :key="columnItem.column_id">
          <ListTableHeaderItem name="用途地域" sort-name="use_districts" @search="search" />
        </th>
        <th v-if="columnItem.column_id === 11 && columnItem.f_display === 1" :key="columnItem.column_id">
          <ListTableHeaderItem name="総戸数" sort-name="total_room_count" @search="search" />
        </th>
      </template>
    </tr>

    <!-- 3行目 -->
    <tr>
      <template v-for="columnItem in column">
        <th v-if="columnItem.column_id === 3 && columnItem.f_display === 1" :key="columnItem.column_id">
          <ListTableHeaderItem name="階建" sort-name="floor" inline @search="search" style="margin-right: 4px;" />
          ・
          <ListTableHeaderItem name="所在階" sort-name="floor_no" inline @search="search" style="margin-right: 4px;" />
          ・
          <ListTableHeaderItem name="号室" sort-name="room_no" inline @search="search" />
        </th>
        <th v-if="columnItem.column_id === 5 && columnItem.f_display === 1" :key="columnItem.column_id">
          <ListTableHeaderItem name="向き" sort-name="open_direct" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 6 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          class="editable"
        >
          <ListTableHeaderItem name="修繕積立金" sort-name="repair_reserve_cost" @search="search" />
        </th>
        <th v-if="columnItem.column_id === 7 && columnItem.f_display === 1" :key="columnItem.column_id">
          <ListTableHeaderItem name="専有面積" sort-name="exclusive_area" @search="search" />
        </th>
        <th v-if="columnItem.column_id === 9 && columnItem.f_display === 1" :key="columnItem.column_id">
          <ListTableHeaderItem name="容積率" sort-name="land_capacity_ratio" @search="search" />
        </th>
        <th v-if="columnItem.column_id === 10 && columnItem.f_display === 1" :key="columnItem.column_id">
          <ListTableHeaderItem name="都市計画" sort-name="city_planning" @search="search" />
        </th>
        <th
          v-if="columnItem.column_id === 11 && columnItem.f_display === 1"
          :key="columnItem.column_id"
          class="editable"
        >
          <ListTableHeaderItem
            name="満室時年収"
            sort-name="income_price_year"
            inline
            @search="search"
            style="margin-right: 4px;"
          />
          ・
          <ListTableHeaderItem name="月収" :sort="false" inline />
        </th>
      </template>
    </tr>
  </thead>
</template>

<script>
import ListTableHeaderItem from './ListTableHeaderItem'
export default {
  components: {
    ListTableHeaderItem,
  },
  data() {
    return {}
  },
  props: {
    tableColWidth: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  computed: {
    column: {
      get() {
        return this.$store.getters['Column/getColumns']
      },
      set(val) {
        this.$store.commit('Column/setColumns', val)
      },
    },
  },
  methods: {
    search() {
      this.$emit('search')
    },
  },
}
</script>

<style lang="scss" scoped></style>
